import React from 'react';
import styled, { css } from 'styled-components';
import { timingFunctions } from 'polished';
import QRCodeRender from 'react-qr-code';

import Header from './components/Header';
import Items from './components/Items';
import Footer from './components/Footer';

import {
  getServerUrl,
} from '../../helpers/copyToClipboard';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  pointer-events: none;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5px;

  ${({ outlet }) => outlet && css`
    background: white;
    padding: 29px;
    border-radius: 20px;
    box-shadow: 0 0 20px hsla(0, 0%, 0%, 0.07);
  `};

  pointer-events: initial;
`;

const StyledQR = styled(QRCodeRender)`
  position: fixed;
  flex: 0 0 auto;
  z-index: -1;

  opacity: 0;
  transform: translateY(-250px);
  animation:
    fadeInQR 1000ms 150ms forwards ${timingFunctions('easeOutQuint')};
  @keyframes fadeInQR {
    100% { 
      opacity: 1;
      transform: translateY(-350px);
    }
  }
`;

const HeaderImage = styled.img`
  position: fixed;
  flex: 0 0 auto;
  z-index: -1;
  width: 100%;
  max-width: 800px;
  height: 450px;
  margin-top: -460px;
  object-fit: cover;
  border-radius: 10px;

  opacity: 0;
  transform: scale(1.2);
  animation:
    fadeInImage 1500ms 500ms forwards ${timingFunctions('easeOutQuint')};
  @keyframes fadeInImage {
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const Logo = styled.img`
  width: 100%;
  max-width: 180px;
  margin: 50px auto 10px;
`;

const Content = ({ store, order, outlet }) => (
  <Wrapper>
    {store?.posHeaderImage
      ? <HeaderImage src={store?.posHeaderImage?.src} />
      : null}
    <StyledQR
      key="qrcode"
      value={`${getServerUrl()}/order/${order._id}`}
      bgColor="transparent"
      fgColor={store.posQrCodeColor || 'black'}
    />
    <Container outlet={outlet}>
      <Header order={order} />
      <Items items={order.items} store={store} />
      <Footer order={order} />
      <Logo src={store.logo.src} />
    </Container>
  </Wrapper>
);

export default Content;
